import ReactDOMServer from 'react-dom/server';

import { TESTATE } from './constants';

export const isNumber = (value) =>
  typeof value === 'number' && !Number.isNaN(value) && value !== Infinity && value !== -Infinity;

export const isString = (value) => Object.prototype.toString.call(value) === '[object String]';

export const pxToRem = (target, base = 16) => {
  if (isNumber(target)) {
    return `${target / base}rem`;
  } else if (isString(target) && target.endsWith('px')) {
    return `${parseInt(target.slice(0, -2)) / base}rem`;
  } else {
    throw new Error('Argument passed in is not a number nor a pixel value');
  }
};

export const hexToRgb = (hex) => {
  return hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16))
    .join(', ');
};

export const svgComponentToDataURI = (component) => {
  return 'data:image/svg+xml,' + escape(ReactDOMServer.renderToStaticMarkup(component));
};

export const getTestata = () => (window.globals || { testata: 'qn' }).testata || 'qn';

export const getBrandColor = () =>
  TESTATE[getTestata()].color || Object.entries(getTestata())[0][1].color;

export const isYear = (year) => (year ? 'year' : 'month');

export const getReturnUrl = () => {
  return getAndSanitizeQS('returnTo');
};

export const getInitialOffer = (list) => {
  const startingOffer = getAndSanitizeQS('offer');
  let initialOffer = {};
  if (startingOffer !== null) {
    initialOffer = list.find((offer) => offer.metadata.code_name === startingOffer);
  } else {
    initialOffer = list.find(
      (offer) =>
        offer.metadata.code_name === (offer.metadata?.preferred_code_name || 'online-annuale'),
    );
  }
  return initialOffer;
};

export const filterOffersByCodeName = (offers, qs) => {
  let { products } = offers;
  if (qs != null) {
    products = products.filter(({ codeName }) => codeName === qs);
  }
  return { ...offers, products };
};

export const transformOnlineStripeOffers = (offers) => {
  const offerTitle = offers[0].metadata.title || 'Offer Title';
  const offerTitleDescription = offers[0].metadata.title_description || '';
  const offerDescriptionOffer = offers[0].metadata.description_offer || '';
  const benefitsTitle = offers[0].metadata.title_description_offer || '';
  const products = offers.map(({ type, metadata }) => ({
    offerTitle: type,
    offerSubtitle: '',
    offerSavings: metadata.savings,
    codeName: metadata.code_name,
    price: metadata.price,
    renew: metadata.renew,
  }));
  return {
    id: 'offer-online',
    title: offerTitle,
    subtitle: offerTitleDescription,
    description: offerDescriptionOffer,
    benefitsTitle,
    products,
    goTo: '',
  };
};

export const getAndSanitizeQS = (name) => {
  try {
    const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
    const value = urlParams.get(name);
    const regex = /[a-zA-z-]/;
    return regex.test(name) && regex.test(value) ? value : '';
  } catch (e) {
    return null;
  }
};

export const getOfferId = (subscription, list) =>
  list.find(({ interval }) => interval === isYear(subscription)).id;

export const goToHref = (where) => () => {
  window.location.href = where;
};
